<template>
  <div>
    <div class="header">
      <h1 class="page-title">自定义下单</h1>
    </div>
    <el-card class="box-card">
      <el-form
        style="margin-left:300px"
        :model="ruleForm1"
        :rules="rules1"
        ref="f1"
        label-width="100px"
      >
        <el-form-item width="100px" label="产品名称" prop="title">
          <el-input class="input_item" width="100px" v-model="ruleForm1.title"></el-input>
        </el-form-item>
        <el-form-item label="尺寸" prop="size">
          <el-input class="input_item" v-model="ruleForm1.size"></el-input>
        </el-form-item>
        <el-form-item label="数量" prop="number">
          <el-input class="input_item" v-model="ruleForm1.number"></el-input>
        </el-form-item>
        <el-form-item label="面数" prop="mainshu">
          <el-select v-model="ruleForm1.mainshu" placeholder="请选择面数">
            <el-option label="单面" value="1"></el-option>
            <el-option label="双面" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="款数" prop="kuanshu">
          <el-input class="input_item" v-model="ruleForm1.kuanshu"></el-input>
        </el-form-item>
        <el-form-item label="重量" prop="goods_weight">
          <el-input class="input_item" v-model="ruleForm1.goods_weight"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input class="input_item" v-model="ruleForm1.remarks"></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input class="input_item" v-model="ruleForm1.price"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <select
            name="address"
            id="addressSelect"
            style="margin-right:15px"
            @change="Addressselect()"
          >
            <template v-if="addressList!=='[]'">
              <option
                :value="item.provice_id"
                v-for="(item,index) in addressList"
                :key="index"
                :id="item.id"
              >{{item.address}} {{item.query}} {{item.shopping_name}} {{item.shopping_phone}}</option>
            </template>
            <template v-else>
              <option value="0">暂无地址，请添加收货地址</option>
            </template>
          </select>
          <el-button type="primary" size="small" id="addAddress" @click="showDialog()">添加地址</el-button>
        </el-form-item>
        <el-form-item label="上传源文件">
          <div class="f">
            <form name="theform">
              <input
                style="display:none"
                type="radio"
                name="myradio"
                checked="true"
                value="local_name"
              />
              <input style="display:none" type="radio" name="myradio" value="random_name" />
              <input style="display:none" type="text" id="dirname" :value="filePath" size="50" />
            </form>
            <div class="contaniner">
              <a href="javascript:void(0);" class="btn" style="margin-left:0" id="selectfiles">上传源文件</a>
            </div>
            <div id="ossfile"></div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sub('f1')">立即下单</el-button>
        </el-form-item>
      </el-form>

      <div v-show="JSON.stringify(tableData)!='[]'">
        <el-table :data="tableData" border style="width: 100%" max-height="500" v-loading="loading">
          <el-table-column :resizable="false" type="index" label="序号"></el-table-column>
          <el-table-column :resizable="false" prop="file" label="文件名" width="300"></el-table-column>
          <el-table-column :resizable="false" prop="product_name" label="产品种类" width="120"></el-table-column>
          <el-table-column :resizable="false" prop="number" label="数量" width="80"></el-table-column>
          <el-table-column :resizable="false" prop="title" label="规格" width="190"></el-table-column>
          <el-table-column :resizable="false" prop="kuanshu" label="款数" width="60"></el-table-column>
          <el-table-column :resizable="false" label="价格" width="120">
            <template slot-scope="scope">{{scope.row.craft_price + scope.row.goods_price}}</template>
          </el-table-column>
          <el-table-column :resizable="false" prop="product_weight" label="重量(kg)" width="90"></el-table-column>
          <el-table-column :resizable="false" prop="total_price" label="总计" width="120"></el-table-column>
          <el-table-column :resizable="false" prop="shopping_name" label="收货信息" width="280">
            <template slot-scope="scope">
              <div v-if="scope.row.shopping_name!==null">
                <p>收 货 人：{{scope.row.shopping_name}}</p>
                <p>配送地址：{{scope.row.address_text}}</p>
                <p>详细地址：{{scope.row.address_query}}</p>
              </div>
              <el-button class="checkAddress" type="primary" v-else size="mini">选择地址</el-button>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="danger" @click="delCar(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <button @click="goZhifu" class="sy_zf">去支付</button>
      </div>
    </el-card>
    <el-dialog :visible.sync="dialogVisible" title="添加地址" width="40%">
      <el-form
        style="margin-top:10px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="收货人姓名" prop="shopping_name">
          <el-input v-model="ruleForm.shopping_name" placeholder="姓名长度不超过25个字符"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="shopping_phone">
          <el-input v-model="ruleForm.shopping_phone" placeholder="请输入收货人的手机号码"></el-input>
        </el-form-item>
        <v-distpicker @selected="onSelected"></v-distpicker>
        <el-form-item label="详细地址" prop="query">
          <el-input v-model="ruleForm.query" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm1('ruleForm')">添加地址</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import '../../../../public/PLupload/lib/crypto1/crypto/crypto.js'
import '../../../../public/PLupload/lib/crypto1/hmac/hmac.js'
import '../../../../public/PLupload/lib/crypto1/sha1/sha1.js'
import '../../../../public/PLupload/lib/base64.js'
import plupload from 'plupload'
import { log } from 'util'

let accessid = 'LTAIKIMZYqT7o3sd'
let accesskey = 'bOqt3eOIbDRYkaDIgb84Q8dKyJF6fT'
let host = 'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com'

let g_dirname = ''
let g_object_name = ''
let g_object_name_type = ''
let timestamp
let now = (timestamp = Date.parse(new Date()) / 1000)
let pos = ''
let suffix = ''

const baseUlr = window.location.host
const url = !baseUlr.includes('192')
  ? 'https://' + baseUlr
  : 'https://www.yunshanyin.net'

var policyText = {
  expiration: '2030-05-01T12:00:00.000Z', // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
  conditions: [
    ['content-length-range', 0, 104857600000000] // 设置上传文件的大小限制
  ]
}
var policyBase64 = window.Base64.encode(JSON.stringify(policyText))
let message = policyBase64
var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true })
var signature = Crypto.util.bytesToBase64(bytes)

function check_object_radio() {
  var tt = document.getElementsByName('myradio')
  for (var i = 0; i < tt.length; i++) {
    if (tt[i].checked) {
      g_object_name_type = tt[i].value
      break
    }
  }
}

function get_dirname() {
  let dir = document.getElementById('dirname').value
  if (dir != '' && dir.indexOf('/') != dir.length - 1) {
    dir = dir + '/'
  }
  g_dirname = dir
}

function random_string(len, filename) {
  let pwd = filename
  return pwd
}

function get_suffix(filename) {
  pos = filename.lastIndexOf('.')
  suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }

  return suffix
}

function calculate_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    g_object_name += '${filename}'
  } else if (g_object_name_type == 'random_name') {
    suffix = get_suffix(filename)
    g_object_name = g_dirname + random_string(10, filename)
  }
  return ''
}

function get_uploaded_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    let tmp_name = g_object_name
    tmp_name = tmp_name.replace('${filename}', filename)
    return tmp_name
  } else if (g_object_name_type == 'random_name') {
    return g_object_name
  }
}

function set_upload_param(up, filename, ret) {
  g_object_name = g_dirname
  if (filename != '') {
    suffix = get_suffix(filename)
    calculate_object_name(filename)
  }
  let new_multipart_params = {
    key: g_object_name,
    policy: policyBase64,
    OSSAccessKeyId: accessid,
    success_action_status: '200', //让服务端返回200,不然，默认会返回204
    signature: signature
  }

  up.setOption({
    url: host,
    multipart_params: new_multipart_params
  })

  up.start()
}
import VDistpicker from 'v-distpicker'

export default {
  components: {
    VDistpicker
  },
  data() {
    return {
      ruleForm1: {
        title: '',
        price: '',
        number: '',
        kuanshu: '',
        mainshu: '',
        size: '',
        remarks: '',
        goods_weight:''
      },
      rules1: {
        title: [{ required: true, message: '请输入产品名', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        number: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        goods_weight: [{ required: true, message: '请输入重量', trigger: 'blur' }],
        kuanshu: [{ required: true, message: '请输入款数', trigger: 'blur' }],
        mainshu: {
          required: true,
          message: '请选择面数',
          trigger: 'change'
        },
        size: [{ required: true, message: '请输入尺寸大小', trigger: 'blur' }],
        remarks: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      },
      ruleForm: {
        // 省id
        provice_id: '',
        //省市区id
        address: [],
        // 详细地址信息
        query: '',
        //名字
        shopping_name: '',
        // 手机号码
        shopping_phone: '',
        ext_number: '',
        token: window.localStorage.getItem('token')
      },
      rules: {
        shopping_name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        shopping_phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '请核对手机号码', trigger: 'blur' }
        ],
        query: [
          { required: true, message: '请输入配送地址', trigger: 'blur' },
          {
            min: 5,
            max: 120,
            message: '详细地址长度需要在5-120个汉字或字符之间',
            trigger: 'blur'
          }
        ]
      },
      file: '',
      filename: '',
      filePath: '',
      //   地址
      addressList: [],
      addressId: '',
      dialogVisible: false,
      tableData: []
    }
  },
  methods: {
    sub(formName) {
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          return
        }
        if (!this.file) {
          return this.$confirm('请上传源文件', '提示')
        }
        let param = new URLSearchParams()
        for (let k in this.ruleForm1) {
          param.append(k, this.ruleForm1[k])
        }
        param.append('address_id', this.addressId)
        param.append('file', this.file)
        param.append('filename', this.filename)
        param.append('token', window.localStorage.getItem('token'))
        const { data: res } = await this.$http.post('api/car/addzdycar', param)
        if (res.code) {
          this.$confirm('下单成功，点击下方去支付', '提示')
          this.queryOrder()
          this.$refs[formName].resetFields()
        }
      })
    },
    async queryAddress() {
      let token = window.localStorage.getItem('token')
      if (token) {
        let param = new URLSearchParams()
        param.append('token', token)
        const { data: res } = await this.$http({
          method: 'post',
          url: '/api/address/index',
          data: param
        })
        res.code == 1
          ? (this.addressList = res.data.sort(this.compare('def')))
          : (this.addressList = [])
      }
      if (JSON.stringify(this.addressList) != '[]') {
        this.addressId = this.addressList[0].id
      }
    },
    // 递归排序
    compare(property) {
      return function(a, b) {
        return b[property] - a[property]
      }
    },
    // 获取选中的checked值
    Addressselect() {
      let optionCheck = $('#addressSelect option:selected').attr('id')
      if (optionCheck == 0) {
        this.addressId = ''
      } else {
        this.addressId = optionCheck
      }
    },
    showDialog() {
      this.dialogVisible = true
    },
    onSelected(data) {
      this.ruleForm.address = []
      this.ruleForm.provice_id = ''
      this.ruleForm.provice_id = data.province.code
      for (let key in data) {
        this.ruleForm.address.push(data[key].code)
      }
    },
    // 验证填写是否完全
    submitForm1(formName) {
      if (this.ruleForm.address.length < 3) {
        this.$message('请选择完整的省市区', 'error')
        return
      }
	  
      for (let i = 0; i < this.ruleForm.address.length; i++) {
        if (!this.ruleForm.address[i]) {
          this.$message('请选择完整的省市区', 'error')
          return
        }
      }
      // this.ruleForm.address = this.ruleForm.address.join(',')
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          return
        } else {
          if (!this.ruleForm.provice_id || !this.ruleForm.address) {
            this.$message('请选择详细地区信息', '提示')
            return
          }
          this.ruleForm.address = this.ruleForm.address.join(',')
          let param = new URLSearchParams()
          for (let key in this.ruleForm) {
            param.append(key, this.ruleForm[key])
          }
          const { data: res } = await this.$http({
            method: 'post',
            url: 'api/address/addaddress',
            data: param
          })
          if (res.code == 1) {
            this.$confirm('添加地址信息成功！', '提示')
            this.queryAddress()
            this.dialogVisible = false
          } else {
            this.$message.error('添加地址失败，未知错误')
          }
        }
      })
    },
    async queryOrder() {
      this.loading = true
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      param.append('cartype', 4)
      const { data: res } = await this.$http.post('api/car/index', param)
      if (res.code) {
        this.loading = false
        this.tableData = res.data
      }
    },
    // 删除订单
    async delCar(id) {
      let param = new URLSearchParams()
      param.append('ids', id)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/delcar',
        data: param
      })
      if (res.code == 1) {
        this.$confirm('删除成功', '提示')
      }
      this.queryOrder()
    },
    goZhifu() {
      window.sessionStorage.setItem('cartype', 4)
      this.$router.push('/paymentOrder')
    }
  },
  created() {
    this.queryAddress()
    this.queryOrder()
  },
  mounted() {
    let u = JSON.parse(window.localStorage.getItem('u'))
    this.filePath =
      'uploads/' +
      u.mobile +
      '/' +
      new Date().toLocaleDateString().replace(/\//g, '-')
    const that = this
    var uploader = new plupload.Uploader({
      runtimes: 'html5,flash,silverlight,html4',
      browse_button: 'selectfiles',
      flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
      silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
      url: 'http://oss.aliyuncs.com',
      init: {
        PostInit: function() {
          document.getElementById('ossfile').innerHTML = ''
        },
        FilesAdded: function(up, files) {
          document.getElementById('ossfile').innerHTML = ''
          set_upload_param(uploader, '', false)
          plupload.each(files, function(file) {
            document.getElementById('ossfile').innerHTML +=
              '<div id="' +
              file.id +
              '">' +
              file.name +
              ' (' +
              plupload.formatSize(file.size) +
              ')<b></b>' +
              '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
              '</div>'
          })
        },

        BeforeUpload: function(up, file) {
          check_object_radio()
          get_dirname()
          set_upload_param(up, file.name, true)
        },
        // 上传进度显示
        UploadProgress: function(up, file) {
          var d = document.getElementById(file.id)
          d.getElementsByTagName('b')[0].innerHTML =
            '<span>' + file.percent + '%</span>'
          var prog = d.getElementsByTagName('div')[0]
          var progBar = prog.getElementsByTagName('div')[0]
          progBar.style.width = 12 * file.percent + 'px'
          progBar.setAttribute('aria-valuenow', file.percent)
        },
        // 上传完成后
        FileUploaded: function(up, file, info) {
          that.filename =
            'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com/' +
            get_uploaded_object_name(file.name)
          that.file = file.name
          that.$confirm('上传成功！', '提示')
        },

        Error: function(up, err) {
          document
            .getElementById('console')
            .appendChild(document.createTextNode('\nError xml:' + err.response))
        }
      }
    })

    uploader.init()
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.box-card {
  position: relative;
  min-height: 750px;
  margin-left: 50px;
}
.sy_xd {
  width: 160px;
  height: 50px;
  font-size: 18px;
  color: #fff;
  background-color: #a77c5a;
}
.progress {
  background-color: red !important;
}
#addressSelect {
  outline: #01cd78;
  width: 500px;
  height: 35px;
  border: 1px solid #a77c5a;
  option {
    height: 20px;
  }
}

.sy_zf {
  float: right;
  margin: 50px 50px 0 0;
  width: 200px;
  height: 50px;
  font-size: 18px;
  color: #fff;
  background-color: #a77c5a;
  cursor: pointer;
}
</style>